import './styles.css'

import { useMemo } from 'react'

import type { WrapperProps } from '~/@types'

type DesignSystemProps = WrapperProps & {
  primary?: string
}

export function DesignSystem({ children, primary }: DesignSystemProps) {
  const style = useMemo(() => {
    const lines: string[] = []
    if (primary) {
      lines.push(`--primary: ${primary};`)
    }

    if (lines.length) {
      return (
        <style type="text/css">
          {`
          :root {
            ${lines.join('\n')}
          }`}
        </style>
      )
    }
  }, [primary])

  return (
    <>
      {style}
      {children}
    </>
  )
}
